<template>
    <Card :title="$t('labels.inventory_status')">
        <div class="card-body">
            <InventoryStatusFieldsetGroup :inventory-status="inventoryStatus" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="teal" @click="create">
                <span>{{ $t('buttons.create') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import InventoryStatusFieldsetGroup from './fieldsets/InventoryStatusFieldsetGroup.vue';
import { httpClient } from '../../../../services/HttpClient';
export default {
    name: "CreateInventoryStatusPage",
    components: {
        Card, AppButton, InventoryStatusFieldsetGroup
    },
    data() {
        return {
            inventoryStatus: {
                uuid: null,
                name: '',
                type: '',
                color: '',
                order: 0
            }
        }
    },
    methods: {
        async create() {
            await httpClient.post('/management/inventory-statuses', {
                name: this.inventoryStatus.name,
                color: this.inventoryStatus.color,
                type: this.inventoryStatus.type,
                order: this.inventoryStatus.order
            }).then((response) => {
                this.$router.push({ name: 'EditInventoryStatusPage', params: { inventoryStatusUuid: response.data.data.uuid } });
            });
        }
    }
}
</script>
